module.exports = __webpack_public_path__ + "img/menu_logo@2x.f13baa7c.png";